import { render, staticRenderFns } from "./BpDataTableDropdown.vue?vue&type=template&id=7bec4528&scoped=true&"
import script from "./BpDataTableDropdown.vue?vue&type=script&lang=js&"
export * from "./BpDataTableDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BpDataTableDropdown.vue?vue&type=style&index=0&id=7bec4528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bec4528",
  null
  
)

export default component.exports